// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  recipeId: __t.string(),
  baseCookSecondsMs: __t.i64(),
  appliance: __t.string(),
  sellPriceCents: __t.i64(),
  satisfactionX100Base: __t.i32(),
  category: __t.string(),
  tier: __t.u32(),
};
